import { createFeatureSelector, createSelector } from "@ngrx/store";
import decodeToken from "src/app/utils/token.util";
import * as fromUser from "../reducers/user.reducer";
import { Option } from "@interfaces/option";
import format from "src/app/utils/formatter.util";
import { descricaoNcm } from "src/app/utils/ncm-descricao.util";

export const selectUserState = createFeatureSelector<fromUser.State>(
  fromUser.userFeatureKey
);

export const selectUserId = createSelector(
  selectUserState,
  (state) => decodeToken(state.token)?.id ?? null
);

export const selectPNCompany = createSelector(
  selectUserState,
  (state) => state.company.pn
);

export const selectNFCompany = createSelector(
  selectUserState,
  (state) => state.company.nf
);

export const selectCertificate = createSelector(
  selectUserState,
  (state) => state.company.certificate
);

export const selectNfePresets = createSelector(
  selectUserState,
  (state) => state.company.nf?.nfePreset
);

export const selectToken = createSelector(
  selectUserState,
  (state) => state.token
);

export const selectAllBudgets = createSelector(
  selectUserState,
  (state) => state.budgets
);

export const selectBudgets = (page: number) =>
  createSelector(selectAllBudgets, (budgets) => budgets[page] ?? []);

export const selectUsage = createSelector(
  selectUserState,
  (state) => state.company.usage
);

export const selectServices = createSelector(
  selectUserState,
  (state) => state.company.nf?.services || []
);

export const selectNcms = createSelector(
  selectUserState,
  (state) => state.company.nf?.ncms || []
);

// No select do produto o código sozinho não diz nada ("8462.49.00"): mostra
// a descrição da tabela NCM junto. O `value` continua sendo só o código.
export const selectNcmsAsOptions = createSelector(selectNcms, (ncms) =>
  ncms.map((ncm) => {
    const codigo = format(ncm.ncm, "ncm");
    const descricao = descricaoNcm(ncm.ncm);

    return {
      display: descricao ? `${codigo} — ${descricao}` : codigo,
      value: ncm.ncm
    } as Option;
  })
);
